var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-6"},[(_vm.loading)?_c('site-map-skelton-loader'):_c('site-map-menu-list-panel',{attrs:{"menu":_vm.menu},on:{"update-favorite":_vm.updateFavorite,"click-url":_vm.clickUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }